import { render } from "./machineId.vue?vue&type=template&id=5a5fb474"
import script from "./machineId.vue?vue&type=script&lang=js"
export * from "./machineId.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__